module.exports = __webpack_public_path__ + "media/landing-page/hive-left-1385b376.png";